export enum WebSocketEventType {
    USER_NOTIFICATION = 'USER_NOTIFICATION',
    FILE_UPLOAD_COMPLETE = 'FILE_UPLOAD_COMPLETE',
    BATCH_UPLOAD_COMPLETE = 'BATCH_UPLOAD_COMPLETE',
    PRICING_COMPLETE = 'PRICING_COMPLETE'
}
